import { Review } from 'themes/organic/components/index';
import { LongContainedSection } from 'themes/organic/components/sections';

import { useReviews } from 'hooks/review/useReviews';

import s from './OrganicReviewList.module.css';

export const OrganicReviewList = () => {
  const { visibleReviews, hasMoreReviews, showMoreReviews } = useReviews();

  return (
    <LongContainedSection id="reviews" title="Reviews">
      {visibleReviews.map((review) => (
        <Review className={s.review} review={review} key={review.id} />
      ))}
      {hasMoreReviews && (
        <button className={s.moreButton} onClick={showMoreReviews}>
          Show more reviews
        </button>
      )}
    </LongContainedSection>
  );
};
